module.exports = __webpack_public_path__ + "img/energy-graphic.343a15b2.png";